import styled from "@emotion/styled";
import Chip from "component/chips/Chip";
import React from "react";
import { PublicStage } from "types/public";

interface Props {
  stages: PublicStage[];
  selectedSlugs: string[];
  onSelect: (slug: string) => void;
  onSelectAll: () => void;
}
const STAGE_ORDER: Record<string, number> = {
  seed: 0,
  venture_growth: 1,
  alumni: 2,
};

const StageList: React.FC<Props> = (props) => {
  const stages = [...props.stages].sort(
    (a, b) => (STAGE_ORDER[a.slug] ?? 99) - (STAGE_ORDER[b.slug] ?? 99)
  );
  const isAllSelect = props.selectedSlugs.length === 0;

  return (
    <Container>
      <span className="sector__list__label font-sub-title4">STAGE</span>
      <div className="sector__list">
        <Chip
          isClickable
          isActive={isAllSelect}
          onClickChip={props.onSelectAll}
          chipType="green-color"
        >
          All
        </Chip>
        {stages.map((item) => {
          return (
            <Chip
              key={item.id}
              isClickable
              chipType="green-color"
              isActive={props.selectedSlugs.includes(item.slug)}
              onClickChip={() => {
                props.onSelect(item.slug);
              }}
            >
              {item.name}
            </Chip>
          );
        })}
      </div>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;

  .sector__list__label {
    min-width: 104px;
    max-width: 104px;
    color: var(--black);
  }

  .sector__list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
  }

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    .sector__list__label {
      min-width: 100%;
      max-width: 100%;
    }
    .sector__list {
      padding-top: 20px;
      padding-bottom: 20px;
      overflow: scroll;
    }
  }
`;

export default StageList;
